/**
 * Parcels Details
 */

// React
import React, { FC, useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

//UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Collapse,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiAlertCircle,
  mdiArchiveOutline,
  mdiArrowRight,
  mdiCalendar,
  mdiCalendarClock,
  mdiCheck,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronUp,
  mdiCityVariant,
  mdiClose,
  mdiCounter,
  mdiFormatListCheckbox,
  mdiKeyOutline,
  mdiMapMarkerOutline,
  mdiPackage,
  mdiPackageVariantClosed,
  mdiPhoneOutline,
  mdiPrinter,
  mdiStateMachine,
  mdiTextBoxSearch,
  mdiWarehouse,
  mdiClockAlertOutline,
  mdiUpdate,
  mdiFileDocumentOutline,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import Can from '../../components/Can';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';

// Rules

// Helper
import { formaterPhoneNumber, translate } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Product, Props } from './interfaces';
import PaginationNumber from '../../components/PaginationNum';
import Client from 'client-sdk/src/client';
import { UnloadAllInventoryItemsRequestBuilder, UpdateInventoryItemsRequestBuilder } from 'client-sdk/src/parcels/parcels';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import parcelItemsRepository from 'client-sdk/src/Repository/parcel-items-repository';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import JalaliUtils from '@date-io/jalaali';
import getProductFileReq from 'client-sdk/src/products/files';
import { getBlockingTickets } from '../../api/ticket/get';

export type Input = {
  serial: string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.5',
        backgroundColor: '#f3ab3e',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      minWidth: '250px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

const Details: FC<Props> = (props: Props): React.ReactElement => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const [ticket, setTicket] = useState(null)
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [openDialogForChangeParcelStatus, setOpenDialogForChangeParcelStatus] =
    useState(false as boolean);
  const [openDialogForItemsNotUnloaded, setOpenDialogForItemsNotUnloaded] =
    useState(false as boolean);
  const [openUnloadItems, setOpenUnloadItems] = useState(false as boolean);
  const [statusChanged, setStatusChanged] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [description, setDescription] = useState('');
  const [product, setProduct] = useState({} as Product);
  const { register, errors, handleSubmit, getValues, setValue, watch } =
    useForm<Input>({
      defaultValues: {
        serial: '',
      },
    });
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openHandleChangeStatus, setOpenHandleChangeStatus] =
    React.useState(false);
  const token = localStorage.getItem('token') || '';

  const [previewItem, setPreviewItem] = useState({} as any);
  const [parcel, setParcel] = useState({});
  const [parcelItems, setParcelItems] = useState([]);
  const [parcelItemsStatus, setParcelItemsStatus] = useState('');
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);

  //Production and Expiration Date Related (Aryan)
  const [openExpDate, setOpenExpDate] = useState(false as boolean);
  const [productionDate, setProductionDate] = useState<Date>();
  const [expirationDate, setExpirationDate] = useState<Date>();
  const [chosenParcelItemId, setChosenParcelItemId] = useState<number>();
  const [dataUpdated, setDataUpdated] = useState<boolean>(false);

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleCloseDialogForItemsNotUnloaded = () => {
    setOpenDialogForItemsNotUnloaded(false);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleSetParcelStatusFunc = (status: string) => {
    handleSetParcelStatus(status);
  };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.updateParcelStatus({ payload });
      handleNotfication('محموله با موفقیت به روز رسانی شد', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
      console.log(error);
    }
  };
  const handleSetParcelStatus = (status: string) => {
    if (status === 'UNLOADED' || status === 'CONFLICTED') setDescription('');
    updateParcelsStatus({
      id: props.match.params.id,
      body: { status: status.replace(/'/g, '"'), description: description },
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        setStatusChanged(!statusChanged);
        history.push('/parcels-warehouse-operator');
      },
    });
    setOpenDialogForItemsNotUnloaded(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          { payload },
          payload.callback
        );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      handleError(error.response);
    }
  };
  const checkSerial = (data: any) => {
    getInventoryItemsWithSerial({
      ...filtersValues,
      serialNumber: { equals: data.serial },
      parcelId: { equals: props.match.params.id },
      callback: () => {
        setValue('serial', '');
      },
    });
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.updateInventoryItems({
        payload,
      });
      handleNotfication('وضعیت آیتم مورد نظر با موفقیت تغییر کرد ', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };

  const handleAllocateUserFunc = () => {
    const inventoryItem = product.id ? product : inventoryItemsWithSerial[0];
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body:
        inventoryItem.status !== 'UNLOADED' ? '"UNLOADED"' : '"NOT_REGISTERED"',
      ...filtersValues,
      callback: () => {
        setStatusChanged(!statusChanged);
      },
    });
    setOpenUnloadItems(false);
  };

  const getInventoryItemsWithStatus = async () => {
    handleChangeParcelStatus();
  };

  const getNotUnloadedParcelItems = () => {
    if (parcel.items) {
      return parcel.items.filter((item: any) => item.status !== 'UNLOADED');
    }
    return [];
  };

  const handleChangeParcelStatus = () => {
    if (getNotUnloadedParcelItems().length !== 0) {
      setOpenDialogForItemsNotUnloaded(true);
    } else {
      setOpenDialogForChangeParcelStatus(true);
    }
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      handleError(error.response);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = { ...action };
    try {
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      handleError(error.response);
    }
  };
  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
  }, [statusChanged, filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    handleCloseBarcode(true);
  }, [inventoryItemsWithSerial]);

  useEffect(() => {
    if (parcel.id) {
      getParcelInventoryItems({
        parcelId: { equals: parcel.id },
      });
      setParcelItems(parcel.items);
    }
  }, [parcel]);

  useEffect(() => {
    if (product.id) {
      handleAllocateUserFunc();
    }
  }, [product]);

  useEffect(() => {
    getTicket()
  }, [])
  const getTicket = async () => {
    const { id } = props.match.params;
    try {
      const res = await getBlockingTickets({'serviceId.in': 1, linkType: 'parcel', linkId: id, 'status.notIn': 'CLOSED'})
      setTicket(res.data[0])
      res.data.length > 0 && handleNotfication('محموله دارای تیکت است.', 'warn')
    } catch (error) {
      handleError(error)
    }
  }

  const handleClose = () => {
    setOpenUnloadItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleCloseBarcode = (setUnloaded: boolean) => {
    // setOpenBarcode(false);
    setValue('serial', '');
    if (setUnloaded && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setProduct({} as Product);
      // setOpenUnloadItems(true);
      handleAllocateUserFunc();
    }
  };

  const handleChangeStatus = (item: any) => {
    updateParcelItemStatus(item);
  };

  const updateParcelItemStatus = async (item: any) => {
    const { id } = props.match.params;
    const payload = {
      id: item.id,
      body:
        item.status === 'UNLOADED'
          ? 'NOT_REGISTERED'.replace(/'/g, '"')
          : 'UNLOADED'.replace(/'/g, '"'),
      callback: () => {
        getParcelWithId(id);
        setOpenHandleChangeStatus(false);
      },
    };
    // console.log(payload.id);
    try {
      const callback = await parcelItemsRepository.updateParcelItemsStatus({
        payload,
      });
      handleNotfication(
        'تغییر وضعیت آیتم محموله با موفقیت انجام شد',
        'success'
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };

  const closeUpdateParcelItem = () => {
    setOpenHandleChangeStatus(false);
  };

  const unloadAllInventoryItems = async () => {
    try {
      const request = new UnloadAllInventoryItemsRequestBuilder()
        .id(props.match.params.id)
        .build();
      const client = new Client(token);
      await client.execute(request);
      handleNotfication(
        'تغییر وضعیت آیتم‌های محموله با موفقیت انجام شد',
        'success'
      );
      getParcelInventoryItems({
        parcelId: { equals: props.match.params.id },
      });
    } catch (err) {
      handleError(err.response)
    }
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string) => {
    if (!status) {
      setParcelItems(parcel.items);
      setParcelItemsStatus(undefined);
      return;
    }
    if (parcelItemsStatus === status) {
      setParcelItemsStatus(undefined);
    } else {
      setParcelItemsStatus(status);
    }
    const newItems = parcel.items.filter((item: any) => item.status === status);
    setParcelItems(newItems);
  };
  //Aryan Changes
  const handleOpenExpirationDateModal = (passedData: any) => {
    setOpenExpDate(true);
    setChosenParcelItemId(passedData.id);
    if (
      !dataUpdated &&
      passedData.inventoryItems[0].productionDate !== null &&
      passedData.inventoryItems[0].expirationDate !== null
    ) {
      setProductionDate(new Date(passedData.inventoryItems[0].productionDate));
      setExpirationDate(new Date(passedData.inventoryItems[0].expirationDate));
    }
  };

  const submitExpDate = (data: any) => {
    updateParcelProdExpDate(data);
  };

  const handleProductionDateChange = (date: Date) => {
    //changeStateForProductionDate
    const newDate = new Date(date);
    // let updatedDate = newDate.toISOString();
    //.split('T')[0]
    setProductionDate(newDate);
    // useWatch({name: "productionDate"});
    setValue('productionDate', newDate);
  };

  const handleExpirationDateChange = (date: Date) => {
    const newDate = new Date(date);
    // let updatedDate = newDate.toISOString();
    setExpirationDate(newDate);
    setValue('expirationDate', newDate);
  };

  const dateFormatter = (date: Date) => {
    return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
      '0' + date.getDate()
    ).slice(-2)}`;
  };

  const updateParcelProdExpDate = async (item: any) => {
    // const {id} = props.match.params;

    const payload = {
      id: chosenParcelItemId,
      body: {
        productionDate: dateFormatter(productionDate),
        expirationDate: dateFormatter(expirationDate),
      },

      callback: () => {
        // getParcelWithId(id);
        setOpenExpDate(false);
      },
    };
    try {
      const callback = await parcelItemsRepository.updateParcelProdExpDate({
        payload,
      });

      handleNotfication(
        'تغییر تاریخ تولید و انقضاء با موفقیت انجام شد',
        'success'
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    } finally {
      setProductionDate(productionDate);
      setExpirationDate(expirationDate);
      setDataUpdated(true);
    }
  };

  const downloadImage = async (id: number, name: string) => {
    try {
      const response = await getProductFileReq(id);
      const file = URL.createObjectURL(response.blob);
      const link = document.createElement('a');
      link.href = file;
      link.setAttribute(
        'download',
        name,
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
      ${parcel.destinationName}
      `}
        </Typography>
        <span className={classes.contentlabelTitle}>{parcel.id}</span>
      </div>

      <Grid
        container
        direction="row"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>

        <Can
          perform="parcel:inventory-items"
          role={authContext.user.role}
          yes={() => (
            <Link
              to={`/parcels/receipts/${parcel.id}`}
              target="_blank"
              style={{ textDecoration: 'none', marginRight: 'auto' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'چاپ رسید'}
              </Button>
            </Link>
          )}
        />
        {ticket && <Button
          variant="contained"
          color="primary"
          size="large"
          style={{ marginRight: '20px' }}
          onClick={() => {
            history.push(
              `/ticketing/${ticket?.id}`
            );
          }}
        >
          سابقه تیکت
        </Button>}
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCityVariant} size={1} className={classes.icon} />
                {'نام شرکت:  '}
              </span>
              <span>{parcel.partnerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {'تعداد آیتم های محموله:  '}
              </span>

              <span>{inventoryItemsCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {'تعداد کارتن:  '}
              </span>

              <span>{parcel.boxCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ تحویل به انبار:  '}
              </span>
              <span>
                <span>
                  {parcel.shippingDate &&
                    `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <div className={classes.collapseIcon}>
            <IconButton onClick={handleCollapse}>
              <Icon
                path={open ? mdiChevronUp : mdiChevronDown}
                color="white"
                size={1}
              />
            </IconButton>
          </div>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid style={{ margin: 0 }} xs={12} container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'نام مسئول حمل:  '}
                  </span>

                  <span>{parcel.agentName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'شماره همراه مسئول حمل:  '}
                  </span>
                  <span>{formaterPhoneNumber(parcel.agentPhoneNumber)}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    {'تاریخ ثبت محموله:  '}
                  </span>
                  <span>
                    <span>
                      {parcel.deliveryDate &&
                        `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFormatListCheckbox}
                      size={1}
                      className={classes.icon}
                    />
                    {'نوع ارسال:  '}
                  </span>
                  <span>{translate(parcel.deliveryType)}</span>
                </div>
              </Grid>

              <Divider className={classes.divider} />

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'شناسه محموله:  '}
                  </span>

                  <span>{parcel.id}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiWarehouse}
                      size={1}
                      className={classes.icon}
                    />
                    {'انبار مقصد:  '}
                  </span>

                  <span>{parcel.destinationName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                    {'بازه تحویل محموله:  '}
                  </span>
                  <span>
                    <span>
                      {parcel.deliveryStartTime &&
                        jMoment(parcel.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      {' - '}
                      {parcel.deliveryEndTime &&
                        jMoment(parcel.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiStateMachine}
                      size={1}
                      className={classes.icon}
                    />
                    {'وضعیت تحویل :  '}
                  </span>
                  <span>{translate(parcel.status, 'parcel')}</span>
                </div>
              </Grid>
              <Divider className={classes.divider} />
              <Grid item xs={12} sm={6}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'آدرس انبار مقصد :  '}
                  </span>
                  <span>{parcel.destinationAddress}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFileDocumentOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'توضیحات :  '}
                  </span>
                  <span>{parcel.description}</span>
                </div>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Paper>
      <Grid
        style={{ marginTop: '30px', marginBottom: '20px' }}
        container
        alignItems="center"
        justify="flex-start"
      >
        <div className={classes.card}>
          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                parcelItemsStatus === 'UNLOADED' ? 'contained' : undefined
              }
              onClick={() => {
                handleFilterStatus('UNLOADED');
              }}
            >
              تخلیه شده
            </Button>
          </div>
          <div className={classes.cardItem}>
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                parcelItemsStatus === 'NOT_REGISTERED' ? 'contained' : undefined
              }
              onClick={() => {
                handleFilterStatus('NOT_REGISTERED');
              }}
            >
              تخلیه نشده
            </Button>
          </div>
        </div>
        <Button
          color="secondary"
          size="medium"
          variant={undefined}
          disabled={
            parcelItemsStatus !== 'UNLOADED' &&
            parcelItemsStatus !== 'NOT_REGISTERED'
          }
          onClick={() => {
            handleFilterStatus('');
          }}
        >
          حذف فیلتر
        </Button>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {!parcel ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            parcelItems && (
              <ListParcelItems
                changeStatus={(item: any) => handleChangeStatus(item)}
                handleOpenExpirationDateModal={handleOpenExpirationDateModal}
                data={parcelItems}
                selectAll={unloadAllInventoryItems}
                checkedAll={getNotUnloadedParcelItems().length == 0}
                downloadImage={downloadImage}
              />
            )
          )}
        </Grid>
        <Grid id="showFilter" item xs={12} sm={6}>
          {inventoryItems && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleCloseSelect}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {inventoryItems && (
            <>
              <Pagination
                count={Math.ceil(parcel.boxCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <PaginationNumber onChange={handleChangePageNum} />
            </>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ marginTop: '30px' }} container justify="flex-end">
        <Button
          aria-label="unload-parcel"
          onClick={getInventoryItemsWithStatus}
          disabled={!!ticket}
          variant="contained"
          color="secondary"
        >
          <span className="">{'تایید تخلیه محموله'}</span>
          <Icon path={mdiChevronLeft} size={1} />
        </Button>
      </Grid>
      <Dialog
        fullWidth
        open={openUnloadItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div>
            {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
        تغییر وضعیت کالا با شناسه
        "${id}"
        به
        "${product.status === 'UNLOADED' ? 'تخلیه نشده' : 'تخلیه شده'}"
      مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: '15px' }}
                  container
                  alignItems="center"
                >
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiArchiveOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {'نام کالا :  '}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.productName}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiKeyOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {'شناسه کالا :  '}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.productId}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiCounter}
                          size={1}
                          className={classes.icon}
                        />
                        {'تعداد :  '}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.amount}</span>
                    </div>
                  </Grid>
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
        تغییر وضعیت کالا با مشخصات بالا
        به تخلیه شده
      مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeParcelStatus}
        onClose={handleCloseDialogForChangeParcelStatus}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForChangeParcelStatus ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseDialogForChangeParcelStatus}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
        تغییر وضعیت محموله به تخلیه شده
      مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeParcelStatus}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetParcelStatusFunc('UNLOADED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openHandleChangeStatus}
        onClose={closeUpdateParcelItem}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {closeUpdateParcelItem ? (
              <IconButton aria-label="close" onClick={closeUpdateParcelItem}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
        تغییر وضعیت آیتم محموله با شناسه
         "${previewItem.id}"
         به 
         "${previewItem.status === 'UNLOADED' ? 'تخلیه نشده' : 'تخلیه شده'}"
      مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={closeUpdateParcelItem}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => updateParcelItemStatus()}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForItemsNotUnloaded}
        onClose={handleCloseDialogForItemsNotUnloaded}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForItemsNotUnloaded ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotUnloaded}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {getNotUnloadedParcelItems().length > 1 ? (
              <div>
                {`تعداد 
            "${getNotUnloadedParcelItems().length}"
            آیتم از کالاها
            مانند آیتم با مشخصات 
          "${'نام کالا'} : ${getNotUnloadedParcelItems()[0]?.productName
                  }  - ${'شناسه تنوع کالا'} : ${getNotUnloadedParcelItems()[0]?.skuId
                  }"
          هنوز تخلیه نشده است و یا مغایرت دارد.`}
              </div>
            ) : (
              <div>
                {`آیتم با شناسه 
            "${getNotUnloadedParcelItems()[0]?.id}"
            هنوز تخلیه نشده است و یا مغایرت دارد.
            `}
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotUnloaded}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'بررسی مجدد'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={e => handleSetParcelStatusFunc('CONFLICTED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'ایجاد مغایرت'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiAlertCircle} size={4} color="#faa320" />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با سریال 
        " ${getValues().serial} "
        یافت نشد.`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="secondary"
              size="large"
            >
              {'باشه'}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => setOpenExpDate(false)}
        open={openExpDate}
        title={
          <div>
            <Icon
              path={mdiClockAlertOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <form onSubmit={handleSubmit(submitExpDate)}>
            <Grid container xs={12} sm={12} lg={12} spacing={2}>
              <Grid item xs={6} sm={6} lg={6} spacing={2}>
                <div className={classes.item}>
                  <span style={{ width: '100%' }}>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        inputVariant="outlined"
                        id="productionDate"
                        name="productionDate"
                        label="انتخاب تاریخ تولید"
                        format="jYYYY/jMM/jDD"
                        value={productionDate}
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={new Date()}
                        onChange={handleProductionDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  </span>
                </div>
              </Grid>

              <Grid item xs={6} sm={6} lg={6} spacing={2}>
                <div className={classes.item}>
                  <span style={{ width: '100%' }}>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        inputVariant="outlined"
                        id="expirationDate"
                        name="expirationDate"
                        label="انتخاب تاریخ انقضاء"
                        format="jYYYY/jMM/jDD"
                        value={expirationDate}
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={new Date()}
                        onChange={handleExpirationDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  </span>
                </div>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    size="large"
                    startIcon={<Icon path={mdiUpdate} size={1} />}
                  >
                    {'به‌روزرسانی تاریخ'}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        }
      />
      <Modal
        maxWidth="lg"
        onClose={() => setOpenBarcode(false)}
        open={openBarcode}
        title={
          <div>
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <form onSubmit={handleSubmit(checkSerial)}>
            <Grid container>
              <Grid xs={12}>
                <div
                  style={{
                    width: '100%',
                    marginBottom: '30px',
                  }}
                >
                  <TextField
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    inputRef={register({ required: true })}
                    error={errors.serial && true}
                  />
                </div>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  size="large"
                  startIcon={<Icon path={mdiTextBoxSearch} size={1} />}
                  disabled={watch('serial')?.length === 0}
                >
                  {'یافتن کالا'}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
    </div>
  );
};

export default Details;
